const Article = {
  NameDescription: "Article.NameDescription",
  UnitDescription: "Article.UnitDescription",
  UnitPriceDescription: "Article.UnitPriceDescription",
  VatDescription: "Article.VatDescription",
  VatDescriptionNotVatRegistered: "Article.VatDescriptionNotVatRegistered",
  VatDescriptionNotVatRegisteredContactSupport: "Article.VatDescriptionNotVatRegisteredContactSupport",
  EuVatTypeDescription: "Article.EuVatTypeDescription",
  Last12Months: "Article.Last12Months",
  Buyer: "Article.Buyer",
  InvoicedQuantities: "Article.InvoicedQuantities",
  EuVatProductType: "Article.EuVatProductType",
  TotalQuantityForLastYearlyPeriod: "Article.TotalQuantityForLastYearlyPeriod",
  TotalAmountForLastYearlyPeriod: "Article.TotalAmountForLastYearlyPeriod",
  NameAndTypeHelpText: "Article.NameAndTypeHelpText",
  StandardPriceHelpText: "Article.StandardPriceHelpText",
  TotalQuantityForLastYearlyPeriodHelpText: "Article.TotalQuantityForLastYearlyPeriodHelpText",
  TotalAmountForLastYearlyPeriodHelpText: "Article.TotalAmountForLastYearlyPeriodHelpText",
  TrendHelpText: "Article.TrendHelpText",
  InvoicedAmount: "Article.InvoicedAmount",
  CreateArticle: "Article.CreateArticle",
  TypeOfArticle: "Article.TypeOfArticle",
  ArticleCreateSuccess: "Article.ArticleCreateSuccess",
  ArticleUpdateSuccess: "Article.ArticleUpdateSuccess",
  ArticlesDistribution: "Article.ArticlesDistribution",
  ArticlesOverTime: "Article.ArticlesOverTime",
  ExportArticleRegisterToCSV: "Article.ExportArticleRegisterToCSV",
  ExportArticleRegisterToEXCEL: "Article.ExportArticleRegisterToEXCEL",
  ImportArticleRegister: "Article.ImportArticleRegister",
  Import: "Article.Import",
  ArticleImportSuccess: "Article.ArticleImportSuccess",
  ActivateArticleDescriptionText: "Article.ActivateArticleDescriptionText",
  ActivateDiableDescriptionText: "Article.ActivateDiableDescriptionText",
  RemoveArticle: "Article.RemoveArticle",
  RemoveArticleTitle: "Article.RemoveArticleTitle",
  RemoveArticleDescriptionText: "Article.RemoveArticleDescriptionText",
  RemoveArticleSuccess: "Article.RemoveArticleSuccess",
  UploadArticlesDescription: "Article.UploadArticlesDescription",
  UploadMappingSectionTitle: "Article.UploadMappingSectionTitle",
  UploadMappingSectionDescription: "Article.UploadMappingSectionDescription",
  UploadUnitDecription: "Article.UploadUnitDecription",
  UploadPriceDecription: "Article.UploadPriceDecription",
  UploadVatDecription: "Article.UploadVatDecription",
  UploadEuVatTypeDecription: "Article.UploadEuVatTypeDecription",
  RevenueAccount: "Article.RevenueAccount",
  RevenueAccountDescription: "Article.RevenueAccountDescription",
  }
export default Article;